import { render, staticRenderFns } from "./index8.vue?vue&type=template&id=4dce13f9&"
import script from "./index8.vue?vue&type=script&lang=js&"
export * from "./index8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports